const unFunction = (fn, ...args) => {
  if (typeof fn === "function") {
    return fn(...args);
  }
  return fn;
};
export {
  unFunction as u
};
//# sourceMappingURL=un-function.js.map
